<template>
  <div>
    <div class="row">
      <div class="col">
        <h1>Edit an offer</h1>
      </div>

      <div class="col-auto">
        <locale-switcher @change="fetchAgain" />
      </div>
    </div>

    <form class="mt-4" @submit.prevent="saveOffers">
      <div class="form-group">
        <label for="parent">
          <small class="text-muted">PRODUCT</small>
        </label>
        <select required class="form-control" name="parent" v-model="product_id" :disabled="loading">
          <option v-for="product in products" :key="product.id" :value="product.id">
            {{ product.name }}
          </option>
        </select>
      </div>
      <div class="form-group">
        <label for="start">
          <small class="text-muted">Start Date</small>
        </label>
        <input type="text" class="form-control" name="start" placeholder="start" v-model="start" required autofocus
          :disabled="loading" />
      </div>
      <div class="form-group">
        <label for="end">
          <small class="text-muted">End Date</small>
        </label>
        <input type="text" class="form-control" name="end" placeholder="end" v-model="end" required autofocus
          :disabled="loading" />
      </div>
      <div class="form-group">
        <label for="new_price">
          <small class="text-muted">New Price</small>
        </label>
        <input type="number" class="form-control" name="new_price" placeholder="new_price" v-model.number="new_price" step="0.01" required
          autofocus :disabled="loading" />
      </div>
      <div class="form-group">
        <label for="notes">
          <small class="text-muted">Notes</small>
        </label>
        <input type="text" class="form-control" name="notes" placeholder="notes" v-model="notes" required autofocus
          :disabled="loading" />
      </div>
      <button type="submit" class="btn btn-primary ld-ext-right mt-3" :disabled="loading" :class="{ running: loading }">
        {{ loading ? "Saving…" : "Save" }}
        <div class="ld ld-ring ld-spin" />
      </button>
    </form>

    <div class="alert alert-danger mt-4" v-if="!loading && error">
      <p class="mb-0 text-center">{{ error }}</p>
    </div>
  </div>
</template>


<script>
import store from "../../../store";
import { getError } from "../../../helpers";
import { mapGetters, mapState } from "vuex";
import LocaleSwitcher from "../../LocaleSwitcher";
import FileInput from "../../FileInput";

export default {
  components: {
    "file-input": FileInput,
    "locale-switcher": LocaleSwitcher,
  },

  async beforeRouteEnter(to, from, next) {
    await store.dispatch("products/fetchAll");

    return store
      .dispatch("offers/fetch", { offersId: to.params.id })
      .then((offers) => {
        next((vm) => {
          vm.product_id = offers.product_id;
          vm.start = offers.start_Date;
          vm.end = offers.end_Date;
          vm.new_price = offers.new_price;
          vm.notes = offers.notes;
        });
      });
  },

  data() {
    return {
      product_id: null,
      start: "",
      end: "",
      new_price: "",
      notes: "",
      loading: false,
      error: "",
    };
  },

  computed: {
    ...mapGetters({
      getOfferById: "offers/getById",
    }),

    offer() {
      return this.getOfferById(parseInt(this.$route.params.id));
    },

    ...mapState({
      products: (state) => state.products.products,
    }),
  },

  methods: {
    saveOffers() {
      this.loading = true;

      return this.$store
        .dispatch("offers/update", {
          offersId: this.$route.params.id,
          product_id: this.product_id,
          start: this.start,
          end: this.end,
          new_price: this.new_price,
          notes: this.notes,
        })
        .then(() => {
          this.$router.push({ name: "offers" });
        })
        .catch(e => {
          this.error = getError(e);
          this.loading = false;
        });
    },

    fetchAgain({ oldValue }) {
      this.loading = true;

      this.$store
        .dispatch("offers/update", {
          offersId: this.$route.params.id,
          product_id: this.product_id,
          start: this.start,
          end: this.end,
          new_price: this.new_price,
          notes: this.notes,
        })
        .then(async () => {
          const offers = await this.$store.dispatch("offers/fetch", {
            offersId: this.$route.params.id,
          });

          this.product_id = offers.product_id;
          this.start = offers.start_Date;
          this.end = offers.end_Date;
          this.new_price = offers.new_price;
          this.notes = offers.notes;
        })
        .catch((e) => {
          this.$store.dispatch("setContentLocale", oldValue);
          this.error = getError(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  meta: {
    title: "Edit an offer",

    meta: [{ property: "og:title", content: "Edit an offer / Shayah" }],
  },
};
</script>

